<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';

  const dispatch = createEventDispatcher();
  export let mobile = false;
  export let lists = [];
  $: lists;
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-lists {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    .back-btn {
      font-weight: 500;
      color: #717171;
      cursor: pointer;
    }

    .list-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      max-width: 400px;
      margin: 20px auto 24px;
      max-height: 50dvh;
      overflow-y: auto;
      /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .list-container::-webkit-scrollbar {
      display: none;
    }

    .list-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border: 1px dashed var(--neutral-input-gray, #c6c6c6);
      text-align: left;
      border-radius: 20px;
      cursor: pointer;
      gap: 16px;

      &.selected {
        cursor: default;
        border: 2px solid #896bd9;
        background: #f1f1f1;
      }

      &:hover {
        background: #f1f1f1;
      }

      .list-image {
        display: flex;
        background: #f1f1f1;
        min-width: 100px;
        width: 100px;
        aspect-ratio: 1/1;
        border-radius: 12px;
        object-fit: cover;
      }

      .list-meta {
        flex: 1;
        overflow: hidden;
      }

      .list-title {
        font-weight: 500;
      }

      .list-description {
        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #7f7f7f;
      }

      .icon__add,
      .icon__added {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        top: 20px;
        right: 20px;
        border: 2px solid #e3e3e3;
        cursor: pointer;
      }

      .icon__added {
        background-color: #000;
        cursor: default;
      }
    }
  }
</style>

<div class="creator-spotlight-lists" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Select List</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>

  <div class="list-container">
    {#each lists as list}
      <div
        class="list-item {list.pinned_on_spotlight && 'selected'}"
        on:click={() => {
          if (!list.pinned_on_spotlight) {
            dispatch('add', list.id);
          }
        }}>
        <img src={list.minified_cover_image} class="list-image" />
        <div class="list-meta">
          <div class="list-title">{list.name}</div>
          <div class="list-description">{list.description}</div>
        </div>
        {#if list.pinned_on_spotlight}
          <div class="icon__added">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.9986 4.28444L14.468 4.81451L7.0105 12.2648C6.32722 12.9474 5.22011 12.9474 4.53683 12.2648L1.53254 9.26344L1.00195 8.73337L2.0621 7.6722L2.59269 8.20227L5.59697 11.2036C5.69458 11.3012 5.85274 11.3012 5.95035 11.2036L13.4079 3.75334L13.9385 3.22327L14.9986 4.28444Z"
                fill="white" />
            </svg>
          </div>
        {:else}
          <div class="icon__add"></div>
        {/if}
      </div>
    {/each}
  </div>
  <div class="back-btn">
    <Button
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={'Continue'}
      on:click={() => {
        dispatch('back');
      }} />
  </div>
</div>
